// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"UserPage_wrapper__3VJyR","table_container":"UserPage_table_container__1-tyu","user_table":"UserPage_user_table__2ZxAT"};